export const usersTranslation = {
  en: {
    users: "Users",
    home: "Home",
    userName: "User Name",
    email: "Email",
    phoneNo: "Phone No.",
    nafathVerified: "Nafath Verified",
    companyName: "Company Name",
    accountType: "Account Type",
    jobTitle: "Job Title",
    createdAt: "Created At",
    lastActivity: "Last Activity",
    status: "Status",
    actions: "Actions",
    editUser: "Edit User",
    addNewUser: "Add New User",
    updateUser: "Update User",
    addUser: "Add User",
    searchByName: "Search by name...",
    addUserButton: "+ Add User",
    edit: "Edit",
    delete: "Delete",
    areYouSureDelete: "Are you sure you want to delete",
    thisActionCannotBeUndone: "This action cannot be undone.",
    firstNameAr: "First Name (AR)",
    fatherNameAr: "Father Name (AR)",
    grandNameAr: "Grand Name (AR)",
    familyNameAr: "Family Name (AR)",
    fatherNameEn: "Father Name (EN)",
    grandNameEn: "Grand Name (EN)",
    familyNameEn: "Family Name (EN)",
    twoNamesAr: "Two Names (AR)",
    twoNamesEn: "Two Names (EN)",
    fullNameAr: "Full Name (AR)",
    fullNameEn: "Full Name (EN)",
    gender: "Gender",
    male: "Male",
    female: "Female",
    dobGregorian: "Date of Birth (Gregorian)",
    dobHijri: "Date of Birth (Hijri)",
    nationalityAr: "Nationality (AR)",
    nationalityEn: "Nationality (EN)",
    nationalId: "National ID",
    language: "Language",
    nafathMobileNumber: "Nafath Mobile Number",
    nafathEmail: "Nafath Email",
    "Nafath Verify": "Nafath Verify",
    "Select date": "Select date",
    nafathDetails: "Nafath Details",
    Verified: "Verified",
    "Not Verified": "Not Verified",
    "(This Field Cannot be Edited)": "(This Field Cannot be Edited)",
    "Password cannot be edited while in Edit mode":
      "Password cannot be edited while in Edit mode",
    firstName: "First Name",
    lastName: "Last Name",
    password: "Password",
    role: "Role",
    member: "Member",
    viewer: "Viewer",
    editor: "Editor",
    cancel: "Cancel",
    allUsers: "All Users",
    verifiedNafath: "Verified Nafath",
    companyUsers: "Company Users",
    individualUsers: "Individual Users",
    userType: "User Type",
    "Choose date range for users": "Choose date range for users",
    "created by": "Created By",
    noofAllowedSignatures: "No. of Allowed Signatures",
    "No. of Allowed Signatures": "No. of Allowed Signatures",
    "No. of Used Signatures": "No. of Used Signatures",
  },
  ar: {
    users: "المستخدمون",
    home: "الصفحة الرئيسية",
    userName: "اسم المستخدم",
    email: "البريد الإلكتروني",
    phoneNo: "رقم الهاتف",
    nafathVerified: "معتمد من نفاذ",
    companyName: "اسم الشركة",
    accountType: "نوع الحساب",
    jobTitle: "المسمى الوظيفي",
    createdAt: "تاريخ الإنشاء",
    lastActivity: "آخر نشاط",
    status: "الحالة",
    actions: "الإجراءات",
    editUser: "تعديل المستخدم",
    addNewUser: "إضافة مستخدم جديد",
    updateUser: "تحديث المستخدم",
    addUser: "إضافة مستخدم",
    searchByName: "البحث حسب الاسم...",
    addUserButton: "+ إضافة مستخدم",
    edit: "تعديل",
    delete: "حذف",
    areYouSureDelete: "هل أنت متأكد أنك تريد حذف",
    thisActionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء.",
    firstNameAr: "الاسم الأول (عربي)",
    fatherNameAr: "اسم الأب (عربي)",
    grandNameAr: "اسم الجد (عربي)",
    familyNameAr: "اسم العائلة (عربي)",
    fatherNameEn: "اسم الأب (إنجليزي)",
    grandNameEn: "اسم الجد (إنجليزي)",
    familyNameEn: "اسم العائلة (إنجليزي)",
    twoNamesAr: "الاسم المركب (عربي)",
    twoNamesEn: "الاسم المركب (إنجليزي)",
    fullNameAr: "الاسم الكامل (عربي)",
    fullNameEn: "الاسم الكامل (إنجليزي)",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    dobGregorian: "تاريخ الميلاد (ميلادي)",
    dobHijri: "تاريخ الميلاد (هجري)",
    nationalityAr: "الجنسية (عربي)",
    nationalityEn: "الجنسية (إنجليزي)",
    nationalId: "الهوية الوطنية",
    language: "اللغة",
    nafathMobileNumber: " رقم جوال نفاذ",
    nafathEmail: "بريد نفاذ",
    "Nafath Verify": "التحقق من نفاذ",
    "Select date": "اختر التاريخ",
    nafathDetails: "تفاصيل نفاذ",
    Verified: "موثق",
    "Not Verified": "غير موثق",
    "(This Field Cannot be Edited)": "(لا يمكن تعديل هذا الحقل)",
    "Password cannot be edited while in Edit mode":
      "لا يمكن تعديل كلمة المرور أثناء وضع التحرير",
    firstName: "الاسم الأول",
    lastName: "الاسم الأخير",
    password: "كلمة المرور",
    role: "الدور",
    member: "عضو",
    viewer: "مشاهد",
    editor: "محرر",
    cancel: "إلغاء",
    allUsers: "جميع المستخدمين",
    verifiedNafath: "نفاذ موثق",
    companyUsers: "مستخدمو الشركة",
    individualUsers: "المستخدمون الفرديون",
    userType: "نوع المستخدم",
    "Choose date range for users": "اختر نطاق التاريخ للمستخدمين",
    "created by": "تم الإنشاء بواسطة",
    noofAllowedSignatures: "عدد التوقيعات المسموح بها",
    "No. of Allowed Signatures": "عدد التوقيعات المسموح بها",
    "No. of Used Signatures": "عدد التوقيعات المستخدمة",
  },
};
